<hd-field-label [label]="label" [subLabel]="description" [showRequiredAsterisk]="control.hasValidator(Validators.required)"></hd-field-label>
<mat-form-field class="w-full" appearance="outline" (focusout)="handleValidationErrors()">
  <textarea matInput [formControl]="control" [placeholder]="'inputs.textearea.placeholder' | translate" [ngClass]="maxLength$$() <= 100 ? 'max-h-[120px]' : 'max-h-[308px]'" [maxlength]="maxLength$$()"></textarea>
  <mat-error hd-field-error [validationErrorMessage]="validationErrorMessage$$()"/>
  @if (maxLength$$();as maxLength) {
    <mat-hint
      align="end"
      [ngClass]="[control.value?.length === maxLength ? 'text-error-fill' : 'text-neutral-30-secondary']">
      {{ control.value ? control.value.length : 0 }}/{{ maxLength }}
    </mat-hint>
  }
</mat-form-field>
